var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status !== 'follows_store')?_c('v-chip',{staticClass:"branch-status-chip",attrs:{"x-small":"","label":"","outlined":"","color":_vm.color}},[_c('v-icon',{attrs:{"x-small":"","left":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.$t("branch_status_" + _vm.status))+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }